import LocaleService from './localeService'
import { has, get } from 'lodash-es'
import { provide } from 'vue'

const LocalePlugin = {
  install: function (Vue, options) {
    // Replace the default config instance, with the loaded config instance from vueapp
    LocaleService.replaceDependency('conf', Vue.conf)
    if (has(options, 'clientLocaleBundle')) {
      LocaleService.replaceLoadedBundle('client', get(options, 'clientLocaleBundle'))
    }
    /**
     * Instance registration
     * @type {{replaceLoadedBundle, replaceDependency, getCurrentLocale, translate, getLoadedBundles}}
     */
    Vue.prototype.$locale = LocaleService
    /**
     * translateItem global method registration
     * @type {{LocaleService}}
     */
    Vue.locale = LocaleService
    /**
     * Locale mixin
     */
    Vue.mixin({
      setup() {
        provide('l10n', LocaleService)

        return {
          locale: LocaleService
        }
      },
      data: () => {
        return {
          locale: LocaleService
        }
      },
      methods: {
        /**
         * @param key
         * @param options {object|boolean}
         * @returns {string}
         */
        t: (key, options = false) => {
          return LocaleService.translate(key, options)
        }
      }
    })
  }
}

export default LocalePlugin
